/**
 * Created by Administrator on 2017/7/2.
 */

import {SHOWBLOG} from './actionTypes.js';

export default (state={}, action) => {
    switch (action.type) {
        case SHOWBLOG: {
            let blog = {};
            Object.assign(blog,action.data);
            return blog;
        }
        default: {
            return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/Component/BlogContent/reducer.js